import {
  CHANGE_LIST_FAIL,
  CHANGE_LIST_SUCCESS,
  INIT_FAIL,
  INIT_SUCCESS,
  UPDATE_FAIL,
  UPDATE_SUCCESS
} from "../actions/evaluationItem";

const initialState = {
  listId: null,
  data: [],
  abolitionFlgTexts: [],
  abolitionFlgValues: [],
  rows: [],
  categoryValueOptions: [],
  evaluationList: [],
  age: null
};

const evaluationItem = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INIT_SUCCESS:
      return {
        ...state,
        listId: payload.listId,
        data: payload.data,
        rows: payload.rows,
        abolitionFlgTexts: payload.abolitionFlgTexts,
        abolitionFlgValues: payload.abolitionFlgValues,
        categoryValueOptions: payload.categoryValueOptions,
        evaluationList: payload.evaluationList,
        age: payload.age
      };
    case INIT_FAIL:
      return {
        ...state,
        listId: null,
        data: []
      };
    case CHANGE_LIST_SUCCESS:
      return {
        ...state,
        listId: payload.listId,
        data: payload.data,
        abolitionFlgTexts: payload.abolitionFlgTexts,
        abolitionFlgValues: payload.abolitionFlgValues,
        categoryValueOptions: payload.categoryValueOptions,
        evaluationList: payload.evaluationList,
        rows: payload.rows,
        age: payload.age
      };
    case CHANGE_LIST_FAIL:
      return {
        ...state,
        listId: payload.listId,
        data: payload.data,
        error: payload.error
      };
    case UPDATE_SUCCESS:
      return {
        ...state,
        params: payload.data
      };
    case UPDATE_FAIL:
      return {
        ...state,
        params: payload.data,
        error: payload.error
      };
    default:
      return {
        ...state,
        listId: null,
        data: []
      };
  }
};

export default evaluationItem;
